<template>
  <div
    class="flex items-center justify-between gap-10 px-10 pb-spacing_7 pt-spacing_6"
  >
    <NuxtLink :to="paths.home">
      <img
        v-if="$appConfig?.web_icon_url"
        class="h-[26px] w-[156px]"
        alt="Quills-logo"
        :src="$appConfig.web_icon_url"
      />
    </NuxtLink>

    <Searchbar
      v-if="enableSearch"
      v-model="searchValue"
      class="search max-w-[740px] flex-1"
      :placeholder="$t('common.actions.search')"
      :autocompleteItems="searchAutocompleteValues"
      @clear-all="$emit('clearAllSearches')"
      @remove-item="$emit('removeFromRecentSearches', $event)"
      @input="$emit('getMatchingKeywords', $event)"
      @submit="$emit('searchSubmit', $event)"
    />

    <ButtonGroup :cart-items-no :is-user-admin />
  </div>
</template>

<script setup lang="ts">
import type { AutocompleteType } from "~/types/schemas/common/Molecule/searchbar";
import paths from "~/constants/paths";
import Searchbar from "~/components/common/Molecule/Searchbar.vue";
import ButtonGroup from "~/components/features/InformativePages/Organism/Header/ButtonGroup.vue";

const searchValue = defineModel<string>("searchValue", { default: "" });

defineProps<{
  searchAutocompleteValues: AutocompleteType;
  cartItemsNo: number | string;
  isUserAdmin?: boolean;
  enableSearch?: boolean;
}>();

defineEmits<{
  openDrawer: [];
  clearAllSearches: [];
  removeFromRecentSearches: [value: string];
  getMatchingKeywords: [value: string];
  searchSubmit: [value: string];
}>();
</script>
